import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { tagsQueryPredicates } from '../queries/tagsQueryPredicates.js';
import { useQueryCacheTagHelpers } from '../utils/useQueryCacheTagHelpers.js';
import { useWoody } from '../../woody/woody.js';
import { toast } from '../../store/alerts.js';

const useMutationTagUpdate = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const { track } = useAnalytics();
  const { updateCachedTag } = useQueryCacheTagHelpers();
  return useMutation({
    mutationFn: async ({ tagId, newName }) => {
      return client.v2({
        endpoint: "/v2/tags/{tagId}",
        params: {
          tagId
        }
      }, {
        method: "patch",
        body: {
          name: newName
        }
      });
    },
    onMutate: ({ tagId, newName }) => {
      return updateCachedTag({
        id: tagId,
        name: newName
      });
    },
    onError: (_e, _v, context) => {
      toast({
        content: "Something went wrong while creating the tag"
      });
      context?.resetCacheToPreOptimisticState();
      context?.invalidateQueries();
    },
    onSuccess: (tag, variables) => {
      track(AnalyticsEvents.RenamedTag, {
        tagId: variables.tagId
      });
      toast({
        content: "Tag renamed successfully"
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        predicate: tagsQueryPredicates.resourcesAll,
        type: "active"
      });
    }
  });
};

export { useMutationTagUpdate };
//# sourceMappingURL=useMutationTagUpdate.js.map
